import { render, staticRenderFns } from "./SolicitacaoPDF.vue?vue&type=template&id=0f8a8fbb&scoped=true&"
import script from "./SolicitacaoPDF.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoPDF.vue?vue&type=script&lang=js&"
import style0 from "./SolicitacaoPDF.vue?vue&type=style&index=0&id=0f8a8fbb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8a8fbb",
  null
  
)

export default component.exports